import { FC, useCallback } from "react";
import { Box } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import {
  DashboardAllStationsFilters,
  DashboardUpdateDateSettings,
  DashboardUpdateSettings,
} from "actions/dashboardActions";
import { useDispatch } from "react-redux";
import { useStyles } from "./style";
import { FilterSwitch } from "componentsNew/elements/TabSwitch";
import { DateFilter } from "componentsNew/elements/DateFilter";
import { MultipleSelectField } from "componentsNew/elements/MultipleSelectField";

interface PropsType {}

const DashboardHead: FC<PropsType> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dashboardSettings } = useTypeSelectors((state) => state.dashboard);
  const { userData } = useTypeSelectors((state) => state.auth);

  const handleChangeDay = (date: string) => dispatch(DashboardUpdateDateSettings({ date }));
  const handleChangeWeek = (week: string) => dispatch(DashboardUpdateDateSettings({ week }));
  const handleChangeMonth = (month: string) => dispatch(DashboardUpdateDateSettings({ month }));
  const handleChangeYear = (year: string) => dispatch(DashboardUpdateDateSettings({ year }));
  const handleChangeSelectType = (select: string) =>
    dispatch(
      DashboardUpdateSettings({
        filterType: select,
      }),
    );

  const handleChangeStations = useCallback(
    (stations: number[]) => {
      dispatch(DashboardUpdateSettings({ stations: stations }));
    },
    [dispatch],
  );

  const handleSelectAllStations = useCallback(
    () => dispatch(DashboardAllStationsFilters()),
    [dispatch],
  );

  const stationOptions = userData.station_spots.map((spot) => ({
    value: spot.station.id,
    label: spot.station.title,
  }));

  return (
    <Box className={classes.paper}>
      <Box className={classes.filters}>
        <Box className={classes.filtersLeft}>
          <MultipleSelectField
            options={stationOptions}
            selected={dashboardSettings.stations}
            action={handleChangeStations}
            actionAll={handleSelectAllStations}
            label="Stations"
            allLabel="All Stations"
            autoSelectAll
          />
          <DateFilter
            type={dashboardSettings.filterType}
            dateValue={dashboardSettings.dateFilters?.date}
            weekValue={dashboardSettings.dateFilters?.week}
            monthValue={dashboardSettings.dateFilters?.month}
            yearValue={dashboardSettings.dateFilters?.year}
            dateChange={handleChangeDay}
            weekChange={handleChangeWeek}
            monthChange={handleChangeMonth}
            yearChange={handleChangeYear}
            hasSwitch
          />
        </Box>
        <FilterSwitch
          type={dashboardSettings.filterType}
          enabledFilters={["year", "month", "week", "date"]}
          action={handleChangeSelectType}
        />
      </Box>
    </Box>
  );
};

export default DashboardHead;
